import React from 'react';
import {Socket} from "rete-react-render-plugin";
import {SOCKET_SIZE} from "../../stylingConstants";
import styled from '@emotion/styled';

const StyledSocketContainerDiv = styled.div`
  width: ${SOCKET_SIZE};
  cursor: default;
`;

export const CustomSocket = (props) => {
    return (
        <StyledSocketContainerDiv>
            <Socket type={props.type} socket={props.socket} io={props.io} innerRef={props.innerRef} />
        </StyledSocketContainerDiv>
    );
}